<p class="debugMessage"><small>data-integration-sensors:</small></p>

<div class="tab-content">
	<ng-container *ngTemplateOutlet="sensorNavBar"></ng-container>
	<ng-container *ngIf="filteredSensorsList then mainSensorList"></ng-container>
</div>

<ng-template #sensorNavBar>
	<nav class="navbar navbar-expand-lg alignRow" style="margin-top: var(--default-margin);">

		<span class="alignRow app-icon app-icon--sensors"><mat-icon /></span>

		<span style="padding-left: var(--default-padding);font-weight: bold;font-size: larger;"
			*ngIf="filteredSensorsList && sensorsList"
			matTooltip="Showing {{filteredSensorsList.length}} of {{sensorsList.length}} Sensors">Sensors&nbsp;({{filteredSensorsList.length}}/{{sensorsList.length}})</span>

		<span style="padding-left: var(--default-padding);">
			<mat-button-toggle-group [value]="showSensors" class="no-tick compact-toggle"
				(change)="toggleButtonGroupFilter($event.value)">
				<mat-button-toggle *ngFor="let btn of BGSelection" [value]="btn.Id" title="{{ btn.Value }}"
					[ngStyle]="{'color': btn.Color}">
					<mat-icon *ngIf="btn.Icon">{{ btn.Icon }}</mat-icon>
					<span *ngIf="!btn.Icon">{{btn.Value}}</span>
				</mat-button-toggle>
			</mat-button-toggle-group>
		</span>

		<span class="alignRow app-icon app-icon--refresh" (click)="refreshSensors()"><mat-icon /></span>

		<ng-container *ngIf="isAdmin(true)">
			<span class="alignRow" style="margin-left: 1em;">
				<span>All Sensors</span>
				<mat-checkbox #topCheckbox color="primary" (change)="toggleAllSensors($event)" color="primary"
					[checked]="allSensorsSelected" [indeterminate]="hasSelectedSensors && !allSensorsSelected"
					(change)="toggleAllSensors($event)" />
			</span>

			<button class="sensor-button" mat-raised-button [disabled]="!hasSelectedSensors"
				[matMenuTriggerFor]="sensorEnableMenu">Enable Selected</button>
			<mat-menu #sensorEnableMenu>
				<button mat-menu-item (click)="enableSelectedSensors(true)">Enable Sensors Only</button>
				<button mat-menu-item (click)="enableSelectedSensors(true, true)">Enable Sensors and DataPoints</button>
			</mat-menu>

			<button class="sensor-button" mat-raised-button [disabled]="!hasSelectedSensors" style="margin-left: 0.5em;"
				(click)="enableSelectedSensors(false)">Disable Selected</button>
		</ng-container>

		<span class="me-auto"></span>
		<app-filter-box (search)="applyFilter($event)" PlaceHolder="Filter Sensor List" />
	</nav>
</ng-template>

<ng-template #mainSensorList>
	<div class="splittersection">
		<ejs-splitter #horizontal separatorSize=4 width='100%' height='calc(100vh - ( var(--site-navBar-Height) * 2 ) )'
			style="margin-top: var(--default-margin);">
			<e-panes>
				<e-pane size='50%' min='25%'>
					<ng-template #content>
						<div class="leftpanel">
							<div class="empty-overlay alignRow" *ngIf="!filteredSensorsList">
								<mat-icon>search_off</mat-icon>
								<div>No sensors found</div>
							</div>
							<div class="empty-overlay alignRow" *ngIf="filteredSensorsList.length == 0">
								<mat-icon>search_off</mat-icon>
								<div>No sensors found Matching this filter</div>
							</div>
							<ejs-listview class="scrollarea" id='listview-scrolling' #listviewInstance
								[dataSource]='filteredSensorsList' cssClass="e-list-template"
								(scroll)='onListScroll($event)' (actionComplete)="onActionComplete($event)"
								(actionBegin)="actionBegin($event)" (select)="selectSensor($event)">
								<ng-template #template *ngIf="!isMobile" let-dataSource="">
									<div class="ejs-listview-item listview-sensor gridRow"
										[ngStyle]="{'color': !dataSource.Enabled ? 'grey':''}">
										<div class="edit " *ngIf="isAdmin(true)">
											<mat-checkbox #sensorCheckbox color="primary"
												[(ngModel)]="dataSource._Selected" />
										</div>
										<img class="image"
											(click)="viewImage(imagePathSensors() + dataSource.SensorID + '?' + dataSource.Modified)"
											src="{{imagePathSensors()}}{{dataSource.SensorID}}?{{dataSource.Modified}}"
											alt="{{dataSource.altText}}"
											onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
										<div class="detail">
											<div class="sensorname">
												<span
													style="margin-right: var(--default-margin);">{{dataSource.Name}}</span>
												<span class="app-icon app-icon--warning">
													<mat-icon *ngIf="dataSource.Offline && dataSource.Enabled"
														title="Sensor Offline" />
												</span>
												<span class="app-icon app-icon--sensorOffline">
													<mat-icon *ngIf="!dataSource.Enabled" title="Sensor Disabled" />
												</span>
												<span style="color:red">
													<mat-icon *ngIf="!dataSource.EnableOffline"
														title="Offline Notifications Disabled">notifications_off</mat-icon>
												</span>

											</div>
											<div id="description" class="description">
												{{dataSource.Description === "" ? "-" : dataSource.Description}}
											</div>
										</div>
										<div class="me-auto"></div>
										<div class="detail" *ngIf="dataSource.Enabled"
											style="text-align: right; padding-right: var(--default-padding);">
											<div class=" lastupdated">
												<span>Last Updated:&nbsp;</span>
											</div>
											<div class=" lastupdated">
												<span><b>{{ !dataSource.Enabled ? 'Disabled' :
														convertEpoch(dataSource.LastValueReceived)
														}}</b></span>
											</div>
										</div>
										<div class="edit gridHover">
											<span class="app-icon "
												[ngClass]="dataSource.NeuronSensors && isAdmin(true) ? 'app-icon--edit-wizard':'app-icon--edit'"
												(click)="editSensor(dataSource, (dataSource.NeuronSensors && isAdmin(true)))"><mat-icon /></span>
										</div>
									</div>
								</ng-template>
							</ejs-listview>
							<span class="filter-result">
								<span *ngIf="showSensors != '1'">{{showSensorText}}</span>
								<span *ngIf="filterValue != ''">Matching {{filterValue}}</span>
							</span>
						</div>
					</ng-template>
				</e-pane>
				<e-pane min='25%'>
					<ng-template #content>
						<div class="rightpanel">
							<ng-container *ngIf="selectedSensor then datapointTabs else selectDatapoint"></ng-container>
						</div>
					</ng-template>
				</e-pane>
			</e-panes>
		</ejs-splitter>
	</div>
</ng-template>

<ng-template #selectDatapoint>
	<span>
		<h1>Select a Sensor</h1>
	</span>
</ng-template>

<ng-template #datapointTabs>
	<div class="alignColumn"
		style="margin-bottom: var(--default-margin);text-align: left;align-items: start;background-color: white;padding: var(--default-padding);"
		*ngIf="selectedSensor">
		<span>
			<h1>{{selectedSensor.Name}}</h1>
		</span>
		<span>Description:&nbsp;<b>{{selectedSensor.Description}}</b></span>
		<span>Last Updated:&nbsp;<b>{{convertEpoch(selectedSensor.LastValueReceived)}}</b></span>
	</div>

	<ejs-tab id="element" headerPlacement="Top" style="margin: 1em;margin-left: 0px;">
		<e-tabitems>
			<e-tabitem>
				<ng-template #headerText>
					<div class="alignRow app-icon app-icon--sensors">
						<mat-icon />
						<span>&nbsp;Datapoints</span>
					</div>
				</ng-template>
				<ng-template #content>
					<ng-container [ngTemplateOutlet]="datapointsList"></ng-container>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<div class="alignRow app-icon app-icon--asset">
						<mat-icon />
						<span>&nbsp;Linked Assets</span>
					</div>
				</ng-template>
				<ng-template #content>
					<ng-container [ngTemplateOutlet]="datapointLinkedAssets"></ng-container>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<div class="alignRow app-icon app-icon--rules">
						<mat-icon />
						<span>&nbsp;Linked Rules</span>
					</div>
				</ng-template>
				<ng-template #content>
					<ng-container [ngTemplateOutlet]="datapointLinkedRules"></ng-container>
				</ng-template>
			</e-tabitem>
			<e-tabitem>
				<ng-template #headerText>
					<div class="alignRow">
						<mat-icon>sensors</mat-icon>
						<span>&nbsp;Offline History</span>
					</div>
				</ng-template>
				<ng-template #content>
					<ng-container [ngTemplateOutlet]="datapointOfflineHistory"></ng-container>
				</ng-template>
			</e-tabitem>
		</e-tabitems>
	</ejs-tab>
</ng-template>

<ng-template #datapointsList>
	<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='sensorDatapoints' cssClass="e-list-template"
		headerTitle="{{selectedSensor?.Name}} Datapoints {{!selectedSensor?.Enabled ? '(Sensor Offline)':''}}"
		showHeader="true" style="min-width: 100%;">

		<ng-template #template *ngIf="!isMobile" let-dataSource="">
			<div class="ejs-listview-item listview-datapoint gridRow"
				[ngStyle]="{'color': !dataSource.Enabled ? 'grey':''}">
				<span class="detail">
					<div class="alignRow name">
						<span>Name:&nbsp;</span>
						<span style="margin-right: var(--default-margin);"><b>{{dataSource.PVName}}</b></span>
						<span class="app-icon app-icon--warning">
							<mat-icon *ngIf="dataSource.Offline && dataSource.Enabled" title="Datapoint Offline" />
						</span>
						<span class="app-icon app-icon--sensorOffline">
							<mat-icon *ngIf="!dataSource.Enabled" title="Datapoint Disabled" />
						</span>
						<span style="color:red">
							<mat-icon *ngIf="!dataSource.EnableOffline"
								title="Offline Notifications Disabled">notifications_off</mat-icon>
						</span>
					</div>
					<div class="alignRow description" *ngIf="dataSource.PVDescription">
						<span>Description:&nbsp;</span>
						<span><b>{{dataSource.PVDescription}}</b></span>
					</div>
					<div class="alignRow units" *ngIf="dataSource.SI">
						<span>Units:&nbsp;</span>
						<span><b>{{dataSource.SI}}</b></span>
					</div>
				</span>
				<div class="me-auto"></div>
				<app-sparkle-line [LineData]="dataSource.SparkleLineData"
					*ngIf="checkFeature(AccountFeatures.Sparkle_Line)"></app-sparkle-line>
				<span class="detail" *ngIf="dataSource.Enabled">
					<div class="lastupdated">
						<span>Last Updated:&nbsp;</span>
					</div>
					<div class="lastupdated">
						<span><b>{{ !dataSource.Enabled ? 'Disabled' : convertEpoch(dataSource.LastValueReceived)
								}}</b></span>
					</div>
				</span>
				<div class="edit gridHover gridMenu"
					style="margin-left: var(--default-margin); color: var(--default-FG-Color);">
					<span class="app-icon app-icon--edit" (click)="editDataPoint(dataSource)"><mat-icon /></span>
					<span class="app-icon app-icon--compare"
						(click)="viewDatapointGraph(dataSource)"><mat-icon /></span>
				</div>
			</div>
		</ng-template>
	</ejs-listview>
</ng-template>

<ng-template #datapointLinkedAssets>
	<div class="listbox-header">
		<span>
			{{ selectedSensor?.Name }} Linked Assets
			<span *ngIf="!selectedSensor?.Enabled">(Sensor Offline)</span>
		</span>
		<span class="toolbar-spacer"></span>
		<button mat-raised-button (click)="linkAsset()">Link Asset</button>
	</div>
	<ejs-listview id="listview-scrolling" #listviewInstance [dataSource]="sensorAssets" cssClass="e-list-template"
		style="min-width: 100%;">
		<ng-template #template *ngIf="!isMobile" let-dataSource="">
			<div class="ejs-listview-item listview-datapoint">
				<img class="image"
					(click)="viewImage(imagePathAssets() + dataSource.AssetID + '?' + dataSource.Modified)"
					src="{{imagePathAssets()}}{{dataSource.AssetID}}?{{dataSource?.Modified}}"
					alt="{{dataSource.Name}} - {{dataSource.Description}}"
					onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
				<span class="detail">
					<div class="alignRow name">
						<span>Name:&nbsp;</span>
						<span style="margin-right: var(--default-margin);"><b>{{dataSource.Name}}</b></span>
					</div>
					<div class="alignRow description" *ngIf="dataSource.Description">
						<span>Description:&nbsp;</span>
						<span><b>{{dataSource.Description}}</b></span>
					</div>
				</span>
				<div class="me-auto"></div>
				<span class="detail" style="padding: 1em;">
					<button mat-raised-button  (click)="goToFunctionalLocation(dataSource)">
						<mat-icon>north_east</mat-icon>
						<span>View</span>
					</button>
				</span>
			</div>
		</ng-template>
	</ejs-listview>
</ng-template>

<ng-template #datapointLinkedRules>
	<div class="listbox-header">
		<span>
			{{ selectedSensor?.Name }} Associated Rules
			<span *ngIf="!selectedSensor?.Enabled">(Sensor Offline)</span>
		</span>
	</div>
	<ejs-listview id="listview-scrolling" #listviewInstance [dataSource]="sensorRules" cssClass="e-list-template"
		*ngIf="sensorRules.length > 0" style="min-width: 100%;">
		<ng-template #template *ngIf="!isMobile" let-dataSource="">
			<div class="ejs-listview-item listview-rule">
				<span class="detail">
					<div class="alignRow name">
						<span>Name:&nbsp;</span>
						<span style="margin-right: var(--default-margin);"><b>{{dataSource.RuleDescription}}</b></span>
						<small *ngIf="!dataSource.RuleEnabled">Disabled</small>
					</div>
					<div class="alignRow description" *ngIf="dataSource.RuleMessage">
						<span>Message:&nbsp;</span>
						<span><b>{{dataSource.RuleMessage}}</b></span>
					</div>
					<div class="alignRow ruleDefinition" *ngIf="dataSource.ReadableRule">
						<span>Rule:&nbsp;</span>
						<span><b>{{dataSource.ReadableRule}}</b></span>
					</div>

				</span>
				<div class="me-auto"></div>
				<div class="edit" style="padding: 1em;">
					<button mat-raised-button (click)="getAssetForRule(dataSource)">
						<mat-icon>north_east</mat-icon>
						<span>View</span>
					</button>
				</div>
			</div>
		</ng-template>
	</ejs-listview>
</ng-template>

<ng-template #datapointOfflineHistory>
	<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='sensorOfflineHistory'
		cssClass="e-list-template"
		headerTitle="{{selectedSensor?.Name}} Offline History {{!selectedSensor?.Enabled ? '(Sensor Offline)':''}}"
		showHeader="true" style="min-width: 100%;">
		<ng-template #template *ngIf="!isMobile" let-dataSource="">
			<div class="ejs-listview-item listview-datapoint">
				<span class="detail">
					<div class="alignRow name">
						<span>Event Text:&nbsp;</span>
						<span style="margin-right: var(--default-margin);"><b>{{dataSource.OfflineEventText}}</b></span>
					</div>
					<div class="alignRow name">
						<span>Timestamp:&nbsp;</span>
						<span
							style="margin-right: var(--default-margin);"><b>{{convertEpoch(dataSource.TimeStamp)}}</b></span>
					</div>
				</span>
				<div class="me-auto"></div>
				<span class="detail" style="padding: 1em;">
					<button mat-raised-button (click)="goToEvent(dataSource)">
						<mat-icon>north_east</mat-icon>
						<span>View</span>
					</button>
				</span>
			</div>
		</ng-template>
	</ejs-listview>
</ng-template>